/* eslint-disable max-len */
import React from 'react'
import Svg, { Path } from 'react-native-svg'

interface CalmIconProps {
  color: string
}

const CalmIcon = (props: CalmIconProps) => {
  const { color } = props
  return (
    <Svg viewBox="0 0 46 46" fill="none">
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23 0C10.315 0 0 10.315 0 23s10.315 23 23 23 23-10.315 23-23S35.685 0 23 0zm0 3c11.064 0 20 8.937 20 20s-8.936 20-20 20C11.937 43 3 34.063 3 23S11.937 3 23 3zm-4.588 26.629a1.437 1.437 0 10-2.324 1.692c1.526 2.096 4.064 3.466 6.912 3.466s5.386-1.37 6.912-3.466a1.437 1.437 0 10-2.324-1.692c-.991 1.36-2.67 2.284-4.588 2.284-1.918 0-3.597-.923-4.588-2.284zm-7.684-12.441a1.438 1.438 0 011.984.44c.65 1.02 1.695 1.634 2.813 1.634s2.163-.614 2.813-1.634a1.438 1.438 0 012.424 1.544c-1.111 1.745-3.02 2.965-5.237 2.965-2.218 0-4.125-1.22-5.237-2.965a1.438 1.438 0 01.44-1.984zm16.934.44a1.438 1.438 0 00-2.424 1.544c1.112 1.745 3.02 2.965 5.237 2.965 2.218 0 4.125-1.22 5.237-2.965a1.438 1.438 0 00-2.424-1.544c-.65 1.02-1.695 1.634-2.813 1.634s-2.163-.614-2.813-1.634z"
        fill={color}
      />
    </Svg>
  )
}

export default CalmIcon
